import { Controller } from '@hotwired/stimulus'

const HIGHLIGHT_CLASSES = ['bg-blue-50', 'ring-1', 'ring-blue-300']
const EXPAND_TRANSITION_MS = 320

export default class extends Controller {
  static targets = ['panel', 'chevron', 'item', 'text']
  static values = { open: { type: Boolean, default: false } }

  toggle = () => {
    this.openValue = !this.openValue
  }

  highlight = (event) => {
    const wasOpen = this.openValue
    this.openValue = true
    // openValueChanged runs async (MutationObserver), so apply the open
    // layout synchronously here too, otherwise scrollIntoView below runs
    // against the stale (still collapsed) layout on the first expand.
    this.applyOpenState(true)

    const item = this.itemTargets.find(el => el.dataset.status === event.params.status)
    if (!item) return

    this.itemTargets.forEach(el => el.classList.remove(...HIGHLIGHT_CLASSES))
    item.classList.add(...HIGHLIGHT_CLASSES)

    // While expanding, the description text wraps and grows taller as its
    // max-width transitions in, so the item's final position isn't known
    // until that settles. Scroll immediately if already open, otherwise
    // wait out the transition first.
    const scrollToItem = () => item.scrollIntoView({ behavior: 'smooth', block: 'end' })
    if (wasOpen) {
      scrollToItem()
    }
    else {
      setTimeout(scrollToItem, EXPAND_TRANSITION_MS)
    }

    clearTimeout(this.highlightTimeout)
    this.highlightTimeout = setTimeout(() => item.classList.remove(...HIGHLIGHT_CLASSES), 1800)
  }

  openValueChanged = (open) => {
    this.applyOpenState(open)
  }

  applyOpenState = (open) => {
    this.chevronTarget.classList.toggle('rotate-180', open)
    this.chevronTarget.parentElement.classList.toggle('mb-4', open)
    this.panelTarget.classList.toggle('flex-row', !open)
    this.panelTarget.classList.toggle('items-center', !open)
    this.panelTarget.classList.toggle('flex-col', open)
    this.panelTarget.classList.toggle('items-start', open)

    this.textTargets.forEach((text) => {
      text.classList.toggle('max-w-0', !open)
      text.classList.toggle('opacity-0', !open)
      text.classList.toggle('whitespace-nowrap', !open)
      text.classList.toggle('max-w-xs', open)
      text.classList.toggle('opacity-100', open)
      text.classList.toggle('whitespace-normal', open)
    })
  }
}
